import { useAuth } from "@/features/auth/hooks/useAuth";
import { PageAccessError } from "@/lib/queries";

/**
 * Synchronous guard for route beforeLoad hooks.
 * Throws PageAccessError immediately (no server round-trip) when the active
 * tenant's stored permissions don't include the requested page, preventing
 * stale-cache flashes of protected content.
 *
 * Falls through silently when activeTenantId is unset — the server check in
 * the loader is the final authority in that case.
 */
export function assertPagePermission(pageSlug: string): void {
  const { tenants, activeTenantId } = useAuth.getState();
  if (!activeTenantId) return;

  const activeTenant = tenants.find((t) => t.id === activeTenantId);
  if (!activeTenant) return;

  const hasPermission = activeTenant.permissions.some(
    (p) => p.type === "PAGE" && p.route === pageSlug,
  );

  if (!hasPermission) throw new PageAccessError(pageSlug);
}
